import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import { makeStyles } from 'tss-react/mui';

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
};

const useStyles = makeStyles()((theme) => ({
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing(1),
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
}));

// component
function ToastContent({ type, message }) {
  const { classes, cx } = useStyles();
  const Icon = variantIcon[type];
  return (
    <span className={classes.message}>
      <Icon className={cx(classes.icon, classes.iconVariant)} />
      {message}
    </span>
  );
}

export default ToastContent;
